/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '@angular/common';
import * as import2 from 'angular2-cookie-law/lib/cookie-law-element.component';
import * as import3 from '@angular/platform-browser';
const styles_CookieLawElementComponent:any[] = ['.cookie-law .cookie-law-wrapper {  background: #333;  color: #bbb;  display: block;  font-family: Helvetica Neue,Helvetica,Arial,sans-serif;  font-size: 15px;  font-weight: 200;  line-height: 20px;  position: fixed;  bottom: 0;  left: 0;  width: 100%;  z-index: 999999999;  font-smooth: always;  -webkit-font-smoothing: antialiased;}.cookie-law .cookie-law-wrapper a {  color: #bbb;  -webkit-transition: color .2s;  transition: color .2s;}.cookie-law .cookie-law-wrapper a:hover {  color: #fff;}.cookie-law .cookie-law-wrapper a:hover svg {  fill: #fff;}.cookie-law .cookie-law-wrapper .dismiss {  display: block;  box-sizing: border-box;  padding: 10px;  position: absolute;  top: 0;  right: 10px;  text-decoration: none;  line-height: 20px;}.cookie-law .cookie-law-wrapper .dismiss svg {  display: block;  fill: #bbb;  width: 20px;  height: 20px;  -webkit-transition: fill .2s;  transition: fill .2s;}.cookie-law .cookie-law-wrapper .copy {  box-sizing: border-box;  padding: 10px 60px 10px 10px;}.cookie-law .cookie-law-wrapper .copy span {  color: #fff;  font-weight: 400;}.cookie-law .cookie-law-wrapper .copy a {  text-decoration: underline;}.cookie-law .cookie-law-wrapper .copy a:active, .copy a:hover {    outline: 0;}@media (min-width: 600px) {    .cookie-law .cookie-law-wrapper .copy {    padding: 20px 60px 20px 20px;    font-size: 18px;    line-height: 24px;  }  .cookie-law .cookie-law-wrapper .dismiss {    top: 10px;    right: 15px;  }  .cookie-law .cookie-law-wrapper .dismiss svg {    width: 24px;    height: 24px;  }}'];
export const RenderType_CookieLawElementComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_CookieLawElementComponent,
      data: {'animation': [{
        name: 'transition',
        definitions: [
          {
            type: 0,
            name: '*',
            styles: {
              type: 6,
              styles: {transform: 'translateY(0)'}
            }

          }
          ,
          {
            type: 0,
            name: 'void',
            styles: {
              type: 6,
              styles: {transform: 'translateY(0)'}
            }

          }
          ,
          {
            type: 0,
            name: 'bottomOut',
            styles: {
              type: 6,
              styles: {transform: 'translateY(100%)'}
            }

          }
          ,
          {
            type: 0,
            name: 'topOut',
            styles: {
              type: 6,
              styles: {transform: 'translateY(-100%)'}
            }

          }
          ,
          {
            type: 1,
            expr: 'void => topIn',
            animation: [
              {
                type: 6,
                styles: {transform: 'translateY(-100%)'}
              }
              ,
              {
                type: 4,
                styles: (null as any),
                timings: '1000ms ease-in-out'
              }

            ]

          }
          ,
          {
            type: 1,
            expr: 'void => bottomIn',
            animation: [
              {
                type: 6,
                styles: {transform: 'translateY(100%)'}
              }
              ,
              {
                type: 4,
                styles: (null as any),
                timings: '1000ms ease-in-out'
              }

            ]

          }
          ,
          {
            type: 1,
            expr: '* => *',
            animation: {
              type: 4,
              styles: (null as any),
              timings: '1000ms ease-out'
            }

          }

        ]

      }
  ]}
}
);
function View_CookieLawElementComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Learn more in our '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',([] as any[]),[
      [
        8,
        'href',
        4
      ]
      ,
      [
        8,
        'target',
        0
      ]
      ,
      [
        8,
        'rel',
        0
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['privacy policy'])),
    (l()(),import0.ɵted((null as any),['. ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.learnMore;
    const currVal_1:any = co.target;
    const currVal_2:any = (co.noopener? 'noopener noreferrer': (null as any));
    ck(v,2,0,currVal_0,currVal_1,currVal_2);
  });
}
function View_CookieLawElementComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['By continuing to browse the site, you\'re agreeing to our use of cookies. '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CookieLawElementComponent_2)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.learnMore;
    ck(v,3,0,currVal_0);
  },(null as any));
}
export function View_CookieLawElementComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'cookie-law-wrapper'
      ]
      ],[[
        24,
        '@transition',
        0
      ]
      ],[[
        (null as any),
        '@transition.done'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import2.CookieLawElementComponent = v.component;
      if (('@transition.done' === en)) {
        const pd_0:any = ((<any>co.afterDismissAnimation($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import1.NgStyle,[
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
      ,{ngStyle: [
        0,
        'ngStyle'
      ]
    },(null as any)),
      (l()(),import0.ɵeld(0,(null as any),(null as any),5,'div',[[
        'class',
        'copy'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import0.ɵeld(0,[[
        'ref',
        1
      ]
    ],(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵncd((null as any),0),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CookieLawElementComponent_1)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'a',[
      [
        'class',
        'dismiss'
      ]
      ,
      [
        'href',
        '#'
      ]
      ,
      [
        'role',
        'button'
      ]

    ]
      ,[[
        8,
        'innerHTML',
        1
      ]
      ],[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import2.CookieLawElementComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.dismiss($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any)))
  ]
  ,(ck,v) => {
    var co:import2.CookieLawElementComponent = v.component;
    const currVal_1:any = co.currentStyles;
    ck(v,1,0,currVal_1);
    const currVal_2:any = (import0.ɵnov(v,3).childNodes.length == 0);
    ck(v,6,0,currVal_2);
  },(ck,v) => {
    var co:import2.CookieLawElementComponent = v.component;
    const currVal_0:any = co.transition;
    ck(v,0,0,currVal_0);
    const currVal_3:any = co.closeSvg;
    ck(v,7,0,currVal_3);
  });
}
function View_CookieLawElementComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'cookie-law-el',([] as any[]),[[
        2,
        'cookie-law',
        (null as any)
      ]
    ],(null as any),(null as any),View_CookieLawElementComponent_0,RenderType_CookieLawElementComponent)),
    import0.ɵdid(114688,(null as any),0,import2.CookieLawElementComponent,[import3.DomSanitizer],(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).cookieLawClass;
    ck(v,0,0,currVal_0);
  });
}
export const CookieLawElementComponentNgFactory:import0.ComponentFactory<import2.CookieLawElementComponent> = import0.ɵccf('cookie-law-el',import2.CookieLawElementComponent,View_CookieLawElementComponent_Host_0,{
  learnMore: 'learnMore',
  target: 'target',
  position: 'position'
}
,{isSeen: 'isSeen'},['*']);
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/~/angular2-cookie-law/lib/cookie-law-element.component.ngfactory.ts